import { get, set } from 'js-cookie';
import { SWRConfiguration } from 'swr/dist/types';

import { localeToLang } from '@project44/translations-utils';

import { User } from '../classes/User';
import { DataState, useFetch } from '../hooks/useFetch';
import { getP44Env } from '../utils/getP44Env';

export interface UseUserArgs {
  swrConfig?: SWRConfiguration;
  skipRedirectOn401?: boolean;
}

export function useUser(options: UseUserArgs = {}): DataState<User> {
  const publicApiBaseUrl = getP44Env().PUBLIC_API_BASE_URL;
  const response = useFetch<User>({
    url: `${publicApiBaseUrl}/api/portal/v2/principal`,
    deserializer: User.fromJSON,
    ...options,
  });

  if (response.data?.locale) {
    const currentLocale = get('locale');
    const locale = String(localeToLang(response.data.locale));

    if (!currentLocale) {
      set('locale', locale, { expires: 7, path: '/' });
      if (locale !== 'en') {
        window.location.assign('/');
      }
    }
  }

  return response;
}
